import { render, staticRenderFns } from "./ContainerDescription.vue?vue&type=template&id=ca01ec50"
import script from "./ContainerDescription.vue?vue&type=script&lang=js"
export * from "./ContainerDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports